var _path, _path2, _path3, _g, _rect, _g2, _rect2, _g3, _rect3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFromOppIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 130,
    viewBox: "0 0 230 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H222C226.418 0 230 3.58172 230 8V130H0V8Z",
    fill: "#ECE7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35.5H98C102.142 35.5 105.5 38.8579 105.5 43V87C105.5 91.1421 102.142 94.5 98 94.5H22C17.8579 94.5 14.5 91.1421 14.5 87V43C14.5 38.8579 17.8579 35.5 22 35.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35.5H98C102.142 35.5 105.5 38.8579 105.5 43V87C105.5 91.1421 102.142 94.5 98 94.5H22C17.8579 94.5 14.5 91.1421 14.5 87V43C14.5 38.8579 17.8579 35.5 22 35.5Z",
    stroke: "#B19DFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9381_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 49C36.5 46.5147 34.4853 44.5 32 44.5C29.5147 44.5 27.5 46.5147 27.5 49C27.5 51.4853 29.5147 53.5 32 53.5C34.4853 53.5 36.5 51.4853 36.5 49ZM37.5 49C37.5 52.0376 35.0376 54.5 32 54.5C28.9624 54.5 26.5 52.0376 26.5 49C26.5 45.9624 28.9624 43.5 32 43.5C35.0376 43.5 37.5 45.9624 37.5 49Z",
    fill: "#3E0EF1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 51.5)",
    fill: "#ECE7FE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9381_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 65C36.5 62.5147 34.4853 60.5 32 60.5C29.5147 60.5 27.5 62.5147 27.5 65C27.5 67.4853 29.5147 69.5 32 69.5C34.4853 69.5 36.5 67.4853 36.5 65ZM33.1465 63.6465C33.3417 63.4512 33.6583 63.4512 33.8535 63.6465C34.0488 63.8417 34.0488 64.1583 33.8535 64.3535L31.8535 66.3535C31.6583 66.5488 31.3417 66.5488 31.1465 66.3535L30.1465 65.3535C29.9512 65.1583 29.9512 64.8417 30.1465 64.6465C30.3417 64.4512 30.6583 64.4512 30.8535 64.6465L31.5 65.293L33.1465 63.6465ZM37.5 65C37.5 68.0376 35.0376 70.5 32 70.5C28.9624 70.5 26.5 68.0376 26.5 65C26.5 61.9624 28.9624 59.5 32 59.5C35.0376 59.5 37.5 61.9624 37.5 65Z",
    fill: "#3E0EF1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 67.5)",
    fill: "#ECE7FE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9381_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 81C36.5 78.5147 34.4853 76.5 32 76.5C29.5147 76.5 27.5 78.5147 27.5 81C27.5 83.4853 29.5147 85.5 32 85.5C34.4853 85.5 36.5 83.4853 36.5 81ZM37.5 81C37.5 84.0376 35.0376 86.5 32 86.5C28.9624 86.5 26.5 84.0376 26.5 81C26.5 77.9624 28.9624 75.5 32 75.5C35.0376 75.5 37.5 77.9624 37.5 81Z",
    fill: "#3E0EF1"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 83.5)",
    fill: "#ECE7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.061 66.0607C138.646 65.4749 138.646 64.5251 138.061 63.9393L128.515 54.3934C127.929 53.8076 126.979 53.8076 126.393 54.3934C125.808 54.9792 125.808 55.9289 126.393 56.5147L134.879 65L126.393 73.4853C125.808 74.0711 125.808 75.0208 126.393 75.6066C126.979 76.1924 127.929 76.1924 128.515 75.6066L138.061 66.0607ZM114 65V66.5H137V65V63.5H114V65Z",
    fill: "#8B6CF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153 23.5H208C212.142 23.5 215.5 26.8579 215.5 31V99C215.5 103.142 212.142 106.5 208 106.5H153C148.858 106.5 145.5 103.142 145.5 99V31C145.5 26.8579 148.858 23.5 153 23.5Z",
    fill: "#653EF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153 23.5H208C212.142 23.5 215.5 26.8579 215.5 31V99C215.5 103.142 212.142 106.5 208 106.5H153C148.858 106.5 145.5 103.142 145.5 99V31C145.5 26.8579 148.858 23.5 153 23.5Z",
    stroke: "#B19DFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 6,
    rx: 3,
    transform: "matrix(1 0 0 -1 157 41)",
    fill: "#ECE7FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 51)",
    fill: "#B19DFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 59)",
    fill: "#B19DFB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 69)",
    fill: "#B19DFB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 77)",
    fill: "#B19DFB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 87)",
    fill: "#B19DFB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 95)",
    fill: "#B19DFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9381_3701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(26 43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9381_3701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(26 59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9381_3701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(26 75)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFromOppIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fromOppIllustration.8291152991218c46f75211700d41a32b.svg";